// extracted by mini-css-extract-plugin
export default {"foodFilter":"FoodFilter_foodFilter__11XAL"};